/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Nav_GroupInputs */

const en_find_nav_group = /** @type {(inputs: Find_Nav_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find`)
};

const pl_find_nav_group = /** @type {(inputs: Find_Nav_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź`)
};

/**
* | output |
* | --- |
* | "Find" |
*
* @param {Find_Nav_GroupInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const find_nav_group = /** @type {((inputs?: Find_Nav_GroupInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Nav_GroupInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_find_nav_group(inputs)
	return en_find_nav_group(inputs)
});